<div class="d-flex flex-column" style="text-align: center">
  <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></b></h2>
  <p class="mt-2">LOADING</p>
</div>